<template>
  <div class="SpecialGuest subWrapper">
    <!-- logo + menu -->
    <LogoMenu :loadmounted="ismobile" :active-name="menuName" />
    <!-- 特邀嘉宾 -->
    <div class="sub_contBox" v-if="!ismobile">
      <div class="contbox_scroll">
        <div class="contbox_top">
          <!-- 特邀嘉宾 txt -->
          <div class="sub_title"><img src="../assets/image/right_arrow.png" /><span>{{ GuestData.seminarTopicName }}</span><img src="../assets/image/left_arrow.png" /></div>
          <!-- 内容 -->
          <div class="NewsCenter_cont sub_cont">
            <IndexSpecialGuest :guest-href="GuestHref" :specia-style="true" :guest-data="GuestData.items" @GuestInfoFn="LookGuestInfoFn" :ispc="ismobile" :issub="true" />
          </div>
        </div>
        <!-- 底部信息 -->
        <Foot />
      </div>
    </div>
    <!-- pc -->
    <div class="sub_contBox" v-else>
      <!-- 面包屑 -->
      <div class="Breadcrumb_box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ GuestData.seminarTopicName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 主体 -->
      <div class="content_box">
        <IndexSpecialGuest :guest-href="GuestHref" :guest-data="GuestData.items" @GuestInfoFn="LookGuestInfoFn" :ispc="ismobile" :issub="true" />
      </div>
    </div>
    <!-- 特邀嘉宾弹窗 -->
    <div class="GuestCoverWrap" v-if="isShowGuestInfo">
      <div class="guest_coverbox">
        <div class="top_coverinfo">
          <img :src="GuestInfo.imagePath" />
          <div class="info">
            <h5>{{ GuestInfo.name }}</h5>
            <p>{{ GuestInfo.abstract }}</p>
            <div class="guest_intr" v-if="ismobile" v-html="GuestInfo.content"></div>
          </div>
        </div>
        <span @click="CloseGuestInfoFn" v-if="ismobile"></span>
        <div v-else class="cover_contentbox" v-html="GuestInfo.content"></div>
      </div>
      <span @click="CloseGuestInfoFn" v-if="!ismobile"></span>
    </div>
    <!-- 底部信息 -->
    <Foot v-if="ismobile" />
  </div>
</template>

<script>
  import LogoMenu from '../components/LogoMenu.vue'
  import { SpecialGuestApi,AccessRecordsApi } from '../request/api.js'
  import IndexSpecialGuest from '../components/IndexSpecialGuest.vue'
  import Foot from '../components/Footer.vue'
  export default{
    name: "SpecialGuest",
    data(){
      return{
        isShowGuestInfo: false,  // 特邀嘉宾弹窗
        GuestData: {},  // 数据
        GuestInfo: {},  // 嘉宾信息
        ismobile: false,
        menuName: '特邀嘉宾',
        GuestHref: {
          url: '/specialGuest',
          name: '特邀嘉宾'
        }
      }
    },
    created() {
      this.menuName = this.$route.query.name;
      this.GuestHref.name = this.menuName;
      this.GuestHref.url = this.$route.path;
      let wid = window.innerWidth;
      if (wid >= 320 && wid <= 1024) {
        this.ismobile = false;
      } else {
        this.ismobile = true;
      }
    },
    mounted() {
      this.GetGuestFn();
      this.AccessRecordsFn();
    },
    methods:{
      // 访问记录
      AccessRecordsFn() {
        AccessRecordsApi({
          seminarTopicId: 6
        });
      },
      // 获取特邀嘉宾数据
      GetGuestFn(){
        SpecialGuestApi({
          PageSize: 0,
          PageNumber: 1,
          Sorting: 'displayindex desc,creationdate asc'
        }).then(res => {
          this.GuestData = res;
        });
      },
      // 特邀嘉宾信息
      LookGuestInfoFn(ind){
        this.GuestInfo = this.GuestData.items[ind];
        this.isShowGuestInfo = true;
        document.documentElement.style.overflowY = 'hidden'; //禁止底层div滚动
      },
      // 关闭特邀嘉宾信息弹窗
      CloseGuestInfoFn(){
        this.isShowGuestInfo = false;
        document.documentElement.style.overflowY = 'auto'; //取消禁止屏幕滚动
      }
    },
    components:{
      LogoMenu,
      IndexSpecialGuest,
      Foot
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 320px) and (max-width: 1024px) {
    /* 特邀嘉宾 弹窗 关闭 */
    .SpecialGuest .GuestCoverWrap>span{
      top: .3rem;
      right: .3rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/SpecialGuest.vue